import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaVendasCliente } from '@/features/relatorio/page/venda/vendas-cliente/RelatorioVendaVendasCliente';

export const Route = createFileRoute('/a/relatorio/venda/vendas-cliente')({
    component: RelatorioVendaVendasCliente,
});
